(function (window, document) {
	'use strict';

	function LayoutEngineManager() {
		this._engines = {};
	}

	LayoutEngineManager.prototype.register = function (type, engine) {
		if (!type || !engine) {
			return;
		}
		this._engines[type] = engine;
	};

	LayoutEngineManager.prototype.create = function (type, root) {
		var engine = this._engines[type];
		if (engine && typeof engine.init === 'function') {
			engine.init(root);
		}
	};

	LayoutEngineManager.prototype.destroy = function (type, root) {
		var engine = this._engines[type];
		if (engine && typeof engine.destroy === 'function') {
			engine.destroy(root);
		}
	};

	LayoutEngineManager.prototype.refresh = function (type, root) {
		var engine = this._engines[type];
		if (engine && typeof engine.refresh === 'function') {
			engine.refresh(root);
		}
	};

	LayoutEngineManager.prototype.recalculate = function (type, root) {
		var engine = this._engines[type];
		if (engine && typeof engine.recalculate === 'function') {
			engine.recalculate(root);
		}
	};

	LayoutEngineManager.prototype.applyAll = function (method, root) {
		var self = this;
		Object.keys(this._engines).forEach(function (type) {
			var engine = self._engines[type];
			if (engine && typeof engine[method] === 'function') {
				engine[method](root);
			}
		});
	};

	function GridLayoutEngine() {}
	GridLayoutEngine.prototype.init = function () {};
	GridLayoutEngine.prototype.destroy = function () {};
	GridLayoutEngine.prototype.refresh = function () {};
	GridLayoutEngine.prototype.recalculate = function () {};

	function CarouselLayoutEngine() {}
	CarouselLayoutEngine.prototype.init = function (root) {
		if (window.ReviewFlowCarousel && typeof window.ReviewFlowCarousel.initAll === 'function') {
			window.ReviewFlowCarousel.initAll(root);
		}
	};
	CarouselLayoutEngine.prototype.destroy = function (root) {
		// Prefer the full cleanup path that removes event listeners and timers.
		if (window.ReviewFlowCarousel && typeof window.ReviewFlowCarousel.destroyAll === 'function') {
			window.ReviewFlowCarousel.destroyAll(root);
			return;
		}
		// Fallback: reset init flag so the carousel can be re-initialized.
		var scope = root || document;
		var carousels = scope.querySelectorAll('.reviewflow-carousel');
		carousels.forEach(function (carousel) {
			if (carousel.dataset) {
				delete carousel.dataset.carouselInitialized;
			}
		});
	};
	CarouselLayoutEngine.prototype.refresh = function (root) {
		this.init(root);
	};
	CarouselLayoutEngine.prototype.recalculate = function (root) {
		this.init(root);
	};

	function MasonryLegacyEngine() {}
	MasonryLegacyEngine.prototype.init = function (root) {
		if (typeof window.reviewflowInitMasonry === 'function') {
			window.reviewflowInitMasonry(root);
		}
	};
	MasonryLegacyEngine.prototype.destroy = function (root) {
		// Delegate to the full cleanup function exported by reviewflow-frontend.js.
		// That function removes all ResizeObservers, MutationObservers, RAF callbacks,
		// transitionend listeners, and img load listeners attached to legacy grids.
		if (typeof window.reviewflowDestroyMasonry === 'function') {
			window.reviewflowDestroyMasonry(root);
		}
	};
	MasonryLegacyEngine.prototype.refresh = function (root) {
		this.init(root);
	};
	MasonryLegacyEngine.prototype.recalculate = function (root) {
		this.init(root);
	};

	function MasonryGridV2Engine() {}
	MasonryGridV2Engine.prototype.init = function (root) {
		if (window.ReviewFlowMasonry && typeof window.ReviewFlowMasonry.init === 'function') {
			window.ReviewFlowMasonry.init(root);
		}
	};
	MasonryGridV2Engine.prototype.destroy = function (root) {
		if (!window.ReviewFlowMasonry || typeof window.ReviewFlowMasonry.destroy !== 'function') {
			return;
		}
		var scope = root || document;
		scope.querySelectorAll('.rf-masonry-v2').forEach(function (grid) {
			window.ReviewFlowMasonry.destroy(grid);
		});
	};
	MasonryGridV2Engine.prototype.refresh = function (root) {
		if (!window.ReviewFlowMasonry || typeof window.ReviewFlowMasonry.refresh !== 'function') {
			return;
		}
		var scope = root || document;
		scope.querySelectorAll('.rf-masonry-v2').forEach(function (grid) {
			window.ReviewFlowMasonry.refresh(grid);
		});
	};
	MasonryGridV2Engine.prototype.recalculate = function (root) {
		this.refresh(root);
	};

	var manager = new LayoutEngineManager();
	manager.register('grid', new GridLayoutEngine());
	manager.register('carousel', new CarouselLayoutEngine());
	manager.register('masonry-legacy', new MasonryLegacyEngine());
	manager.register('masonry-v2', new MasonryGridV2Engine());

	window.ReviewFlowLayoutEngineManager = manager;
	window.ReviewFlowLayoutEngines = {
		GridLayoutEngine: GridLayoutEngine,
		CarouselLayoutEngine: CarouselLayoutEngine,
		MasonryLegacyEngine: MasonryLegacyEngine,
		MasonryGridV2Engine: MasonryGridV2Engine
	};
})(window, document);
